/* tslint:disable */
/* eslint-disable */
export enum TrainingType {
  Iaa = 'IAA',
  Ads = 'ADS',
}
